import { render, staticRenderFns } from "./ExchangeRatesForm.vue?vue&type=template&id=187432c6"
import script from "./ExchangeRatesForm.vue?vue&type=script&lang=js"
export * from "./ExchangeRatesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports